<template>
  <!--
    The old "Register / Track your walks" form has been replaced by the
    newsletter signup. This component is kept as a thin wrapper so every page
    that already embeds <UserForm /> shows the newsletter without further edits.
  -->
  <NewsletterForm />
</template>

<script>
import NewsletterForm from "@/components/NewsletterForm.vue";

export default {
  name: "UserForm",
  components: {
    NewsletterForm,
  },
};
</script>
